import React from 'react';
import { Button, Col, Form, Icon, Input, Row } from 'antd';
import OnboardingOptionalStepNotice from './OnboardingOptionalStepNotice';

const FormItem = Form.Item;

export default function OrganisationStep({
  form,
  initialValues,
  isSubmitting,
  showSkip = false,
  onBack,
  onSkip,
  onContinue,
}) {
  const { getFieldDecorator } = form;

  return (
    <div className="onboarding-registration-panel-body">
      <div className="onboarding-registration-panel-main">
        {showSkip ? (
          <OnboardingOptionalStepNotice
            tone="organisation"
            message="This step is optional. Complete it now or use Skip for now below."
          />
        ) : null}

        <FormItem label="Full business name">
          {getFieldDecorator('businessName', {
            initialValue: initialValues.businessName,
            rules: [
              { required: true, whitespace: true, message: 'Please enter the full business name.' },
            ],
          })(<Input placeholder="Legal registered name" disabled={isSubmitting} />)}
        </FormItem>

        <FormItem label="Trading name">
          {getFieldDecorator('tradingName', {
            initialValue: initialValues.tradingName,
            rules: [{ required: true, whitespace: true, message: 'Please enter the trading name.' }],
          })(<Input placeholder="Name used day-to-day" disabled={isSubmitting} />)}
        </FormItem>

        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <FormItem label="Business reg. no. (optional)">
              {getFieldDecorator('registrationNumber', {
                initialValue: initialValues.registrationNumber,
              })(<Input placeholder="ABN / ACN" disabled={isSubmitting} />)}
            </FormItem>
          </Col>
        </Row>
      </div>

      <div className="onboarding-registration-actions onboarding-registration-actions-between onboarding-registration-actions-bar">
        <Button htmlType="button" onClick={onBack} disabled={isSubmitting}>
          Back
        </Button>
        <div className="onboarding-registration-actions-primary-group">
          {showSkip ? (
            <Button
              type="link"
              className="onboarding-registration-skip-link"
              htmlType="button"
              onClick={onSkip}
              disabled={isSubmitting}
            >
              Skip for now
            </Button>
          ) : null}
          <Button type="primary" htmlType="button" loading={isSubmitting} onClick={onContinue}>
            Continue <Icon type="arrow-right" />
          </Button>
        </div>
      </div>
    </div>
  );
}
